// extracted by mini-css-extract-plugin
export default {"shimmering":"styles_shimmering__XU3U7","textShine":"styles_textShine__5X-XA"};